import React, { useState, useRef, useEffect } from 'react';

const StableInput = ({ 
  type = "text",
  value, 
  onChange, 
  disabled, 
  placeholder,
  className = "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent",
  ...props
}) => {
  const [localValue, setLocalValue] = useState(value);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  // Update local value when prop changes, but only if not focused
  useEffect(() => {
    if (!isFocused) {
      setLocalValue(value);
    }
  }, [value, isFocused]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    
    // Don't call parent onChange while focused to prevent re-renders
    // The parent will be updated when the input loses focus
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
    
    // Update parent with the final value when blurring
    const syntheticEvent = {
      target: { value: localValue },
      preventDefault: () => {},
      stopPropagation: () => {}
    };
    onChange(syntheticEvent);
  };

  return (
    <input
      ref={inputRef}
      type={type}
      value={localValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      {...props}
    />
  );
};

export default StableInput;

